import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "@mui/material/SnackbarContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Button } from "../core/views/Button";
import React, { useState } from "react";
import Cookies from "js-cookie";
import { UpsolverLocalStorage } from "../core/UpsolverLocalStorage";
import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import createStyles from "@mui/styles/createStyles";

const useStyles: any = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      border: `1px solid ${theme.palette.grey["300"]}`,
      color: theme.palette.text.primary,
      width: "80vw"
    }
  })
);

function useCookieNotification() {
  const cookieName = "upsolver-cn";
  const cookieValue = "dismissed";
  const [dismissed, setDissmissed] = useState(
    () => Cookies.get(cookieName) === cookieValue || Object.keys(UpsolverLocalStorage.get()).length > 0
  );

  const onDismiss = () => {
    Cookies.set(cookieName, cookieValue, { expires: 1000, secure: true });
    setDissmissed(true);
  };

  return { dismissed, onDismiss };
}

function CookieNotification() {
  const { dismissed, onDismiss } = useCookieNotification();
  const classes = useStyles();
  if (dismissed) {
    return null;
  }
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      open
      onClose={onDismiss}
    >
      <SnackbarContent
        classes={classes}
        message={
          <Box ml={1} mr={2} flexGrow={1}>
            <Typography variant="body1">
              We use cookies to ensure that we give you the best experiance on our websites. If you continue to use this
              site we will assume that you are happy with it.
            </Typography>
          </Box>
        }
        action={
          <>
            <Button square xsmall type="primary" aria-label="close" onClick={onDismiss}>
              Ok
            </Button>
          </>
        }
      />
    </Snackbar>
  );
}

export default CookieNotification;
